export default {
  founders: {
    en: 'Sergei, Mariya and Andrei, founders of Scentbird',
  },
  title: {
    en: 'We\'re sorry to see you go!',
  },
  text: {
    en: 'We hope you come back sometime soon. Till then, could you tell use why you want to cancel your subscription?',
  },
  submitButton: {
    en: 'Cancel my subscription',
  },
  nevermindButton: {
    en: 'Nevermind',
  },
}
